import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MemoComponent } from './memo.component';
import { MemoRoutingModule } from './memo.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MemoRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    MemoComponent
  ],
  declarations: [
    MemoComponent
  ]
})
export class MemoModule { }
